import template from './fuel_surcharges.edit.html';
import controller from './fuel_surcharges.edit.controller';
import './fuel_surcharges.edit.scss';

let fuelSurchargesEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default fuelSurchargesEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/edit/fuel_surcharges.edit.component.js